/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtractHeadersResponseDto
 */
export interface ExtractHeadersResponseDto {
    /**
     * Array of column headers extracted from the uploaded file
     * @type {Array<string>}
     * @memberof ExtractHeadersResponseDto
     */
    headers: Array<string>;
}

/**
 * Check if a given object implements the ExtractHeadersResponseDto interface.
 */
export function instanceOfExtractHeadersResponseDto(value: object): value is ExtractHeadersResponseDto {
    if (!('headers' in value) || value['headers'] === undefined) return false;
    return true;
}

export function ExtractHeadersResponseDtoFromJSON(json: any): ExtractHeadersResponseDto {
    return ExtractHeadersResponseDtoFromJSONTyped(json, false);
}

export function ExtractHeadersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractHeadersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'],
    };
}

export function ExtractHeadersResponseDtoToJSON(json: any): ExtractHeadersResponseDto {
    return ExtractHeadersResponseDtoToJSONTyped(json, false);
}

export function ExtractHeadersResponseDtoToJSONTyped(value?: ExtractHeadersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'],
    };
}

